import { monthShort, parseDateOnly } from '@voll-intelligence/dates';
import type { DateFieldCopy } from '../../shared/field/date_field.js';

/** The checkout's words for its date fields' calendar; the title is each field's label. */
export interface CheckoutDateCopy {
  readonly placeholder: string;
  readonly confirm: string;
  readonly back: string;
  readonly previousMonth: string;
  readonly nextMonth: string;
}

/** "05 jan 1990": a checkout date as the traveler card and the date fields show it. */
export function formatTravelerDate(value: string | undefined, locale: string): string | undefined {
  if (!value) return undefined;
  const date = parseDateOnly(value);
  if (!date) return value;
  const day = String(date.getDate()).padStart(2, '0');
  return `${day} ${monthShort(date, locale)} ${String(date.getFullYear())}`;
}

/** The kit date field's copy for one checkout date, titled by its label. */
export function checkoutDateCopy(
  date: CheckoutDateCopy,
  title: string,
  locale: string,
): DateFieldCopy {
  const format = (day: string) => formatTravelerDate(day, locale) ?? day;
  return { ...date, title, format, summary: (draft) => format(draft.from ?? '') };
}
